// extracted by mini-css-extract-plugin
export default {"chip":"RouteSuggestion_chip__+iB+O","banner":"RouteSuggestion_banner__mN5lJ","label":"RouteSuggestion_label__-7uy9","reason":"RouteSuggestion_reason__w1LSO"};